import * as Yup from 'yup';
import {
  GetSendOwnerInviteTemplateResponseTO,
  PropertyOwner,
} from 'models/Owner';

export const sendOwnerInviteSchema = () => {
  return Yup.object({
    content: Yup.string().richTextEditorContentRequired(),
    content_htmlContent: Yup.string().required(),
    to: Yup.string().required(),
    subject: Yup.string().required(),
    sendCopyToAgency: Yup.boolean(),
  });
};

export type SendOwnerInviteSchemaFormValues = Yup.InferType<
  ReturnType<typeof sendOwnerInviteSchema>
>;

export function getFormDefaultValues({
  agencyName,
  owner,
  template,
}: {
  agencyName: string;
  owner: PropertyOwner;
  template?: GetSendOwnerInviteTemplateResponseTO | null;
}): SendOwnerInviteSchemaFormValues {
  return {
    content: template?.content ?? '',
    content_htmlContent: template?.content ?? '',
    sendCopyToAgency: true,
    subject: `You have a new message from ${agencyName}`,
    to: owner?.email ?? '',
  };
}
